import { useState, useEffect } from 'react'

const useWidth = (divId) => {
  const [state, setState] = useState(0)

  const handleResize = () => {
    setTimeout(() => {
      try {
        const width = document.getElementById(divId).offsetWidth
        if (width !== state) setState(width)
      } catch (error) {
        console.log('errorAtgetWidth')
      }
    }, 200)
  }

  useEffect(() => {
    if (!window.divId) {
      handleResize()
      window.divId = true
      window.addEventListener('resize', handleResize)
      return () => {
        window.divId = false
        window.removeEventListener('scroll', handleResize)
      }
    }
  })

  return state
}

export default useWidth
